import { useState } from 'react';
import { Button, Card, CardBody, Chip } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import ContactModal from '../../../components/feature/ContactModal';

type CTAProps = {
  seamless?: boolean;
};

export default function CTA({ seamless = false }: CTAProps) {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <>
      <section className={`relative overflow-hidden py-24 ${seamless ? 'bg-transparent' : 'bg-[#0D0D0D]'}`}>
        {!seamless ? (
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute left-[-8%] top-10 h-96 w-96 rounded-full bg-[#F2E6C9]/10 blur-3xl" />
            <div className="absolute right-[-6%] bottom-[-14%] h-[28rem] w-[28rem] rounded-full bg-[#F2E6C9]/12 blur-3xl" />
          </div>
        ) : null}

        <div className="relative z-10 mx-auto max-w-7xl px-6">
          <div>
            <Card
              className="overflow-hidden rounded-[32px] border border-white/10 bg-[rgba(20,20,20,0.92)] shadow-[0_32px_80px_rgba(0,0,0,0.34)]"
            >
              <CardBody className="relative overflow-hidden p-0">
                <img
                  src="/images/plaz.webp"
                  alt=""
                  aria-hidden="true"
                  className="absolute inset-0 h-full w-full object-cover object-right-top"
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      'linear-gradient(90deg, rgba(53, 28, 12, 0.72) 0%, rgba(88, 45, 18, 0.72) 18%, rgba(120, 58, 22, 0.58) 38%, rgba(120, 58, 22, 0.26) 62%, rgba(120, 58, 22, 0) 100%)',
                  }}
                />

                <div className="grid min-h-[28rem] items-stretch lg:min-h-[36rem] lg:grid-cols-2">
                  <div className="relative z-30 p-8 md:p-10 lg:p-12 xl:p-14">
                    <div className="relative max-w-[36rem]">
                      <Chip
                        variant="flat"
                        className="mb-5 border border-[#4a3525] bg-[rgba(26,26,26,0.82)] px-4 py-2 text-sm font-semibold text-brand-green shadow-[inset_0_1px_0_rgba(255,255,255,0.05),0_10px_24px_rgba(0,0,0,0.16)] backdrop-blur-md"
                        startContent={
                          <span className="mr-2 inline-flex items-center">
                            <i className="ri-sparkling-line text-base" />
                          </span>
                        }
                      >
                        {t('home.cta.badge')}
                    </Chip>

                    <h2 className="mb-6 text-3xl font-caprasimo leading-[1.04] text-white md:text-4xl xl:text-5xl">
                      {t('home.cta.title')}
                    </h2>

                    <p className="mb-10 max-w-[32rem] text-lg leading-relaxed text-white/74 md:text-xl">
                      {t('home.cta.description')}
                    </p>

                      <div className="flex flex-col items-start gap-4">
                        <Button
                          type="button"
                          onPress={() => setIsContactModalOpen(true)}
                          className="inline-flex h-auto min-w-[250px] justify-between rounded-[18px] border border-white/12 bg-gradient-to-r from-brand-green via-[#b4ec4b] to-[#c8f06d] px-5 py-3.5 text-[0.98rem] font-black text-[#0D0D0D] shadow-[0_14px_30px_rgba(163,230,53,0.24)] transition-all hover:-translate-y-0.5 hover:shadow-[0_18px_34px_rgba(163,230,53,0.28)]"
                          endContent={
                            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black/10 text-[#0D0D0D] shadow-[inset_0_1px_0_rgba(255,255,255,0.22)]">
                              <i className="ri-arrow-right-line text-base" />
                            </span>
                          }
                        >
                          {t('home.cta.button')}
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div aria-hidden="true" className="hidden lg:block" />
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        presetService={null}
        showBudget={false}
      />
    </>
  );
}
